import { render, staticRenderFns } from "./PopupFooter.vue?vue&type=template&id=6179da09&scoped=true"
import script from "./PopupFooter.vue?vue&type=script&lang=js"
export * from "./PopupFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6179da09",
  null
  
)

export default component.exports